import config from 'config'
import { getJsonHeaders } from '../helpers'

export async function home() {
  const result = await fetch(config.API_URL + '/api/library/home')
  return await result.json()
}

export async function search(term) {
  const result = await fetch(config.API_URL + `/api/library/search/${term}`)
  return await result.json()
}

export async function getShared(id) {
  let url = `/api/library/share/${id}`
  const result = await fetch(config.API_URL + url)
  return await result.json()
}

export async function createShareLink(id, type, body) {
  const res = await fetch(config.API_URL + `/api/library/share/${type}/${id}`, {
    method: 'POST',
    headers: await getJsonHeaders(),
    body: JSON.stringify(body),
  })

  return await res.json()
}

export async function deleteShareLink(id) {
  const res = await fetch(config.API_URL + `/api/library/share/${id}`, {
    method: 'DELETE',
    headers: await getJsonHeaders(),
  })

  return await res.json()
}
